<template>
  <div class="tenant-breadcrumb-bar">
    <button type="button" class="tenant-breadcrumb-back" @click="$emit('back')">
      <i class="el-icon-back" aria-hidden="true" />
      <span>{{ backLabel }}</span>
    </button>
    <el-breadcrumb class="tenant-breadcrumb-list" separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in normalizedItems"
        :key="item.key || index"
      >
        <span
          class="tenant-breadcrumb-item"
          :class="{ 'is-current': item.current, 'is-clickable': item.clickable }"
          @click="select(item)"
        >
          {{ item.label }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'TenantBreadcrumbBar',
  props: {
    backLabel: {
      type: String,
      default: '返回'
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    normalizedItems() {
      return Array.isArray(this.items)
        ? this.items.filter(item => item && item.label != null)
        : []
    }
  },
  methods: {
    select(item) {
      if (item && item.clickable && !item.current) {
        this.$emit('select', item)
      }
    }
  }
}
</script>
